/*
 * Configuratore di ritaglio (Jcrop) — UN motore, DUE cataloghi.
 * ------------------------------------------------------------------
 * Fino al 2026-09-11 questo codice viveva dentro snippets/murals-configurator.liquid
 * con le misure di riferimento (472x300) e le larghezze del telo cablate nel JS.
 * Ora i parametri arrivano dal DOM, e il markup attorno puo' essere quello di
 * Murals o quello della scheda Or.nami:
 *
 *   #config-pattern                    l'immagine su cui si ritaglia; i data-*
 *                                      stanno su di lei o sul contenitore piu'
 *                                      vicino che porta data-ref-w
 *     data-ref-w / data-ref-h          cm reali che l'immagine rappresenta
 *                                      (Murals 472x300, Or.nami il modulo, 87x87)
 *     data-panel                       larghezza del telo in cm, FISSA (Or.nami: 50).
 *                                      Se assente si legge dal supporto scelto
 *                                      (.product-config .product-type .selected)
 *     data-quantity                    selettore del campo quantita' (Murals),
 *                                      facoltativo
 *   .product-config .sizes .w .num     larghezza in cm   (input)
 *   .product-config .sizes .h .num     altezza in cm     (input)
 *   .product-config .sizes .tot .num   m2 del ritaglio   (testo)
 *   .product-config .info-hover        invito che sparisce al primo ritaglio
 *   .product-config .config-avviso     riga di stato (facoltativa): valori
 *                                      riportati al limite, configuratore assente
 *   #config-parameters                 payload: {x,y,width,height,m2,m2_sfrido}
 *
 * Ogni ricalcolo emette `murals:configurator:update` su document, e quando
 * Jcrop non arriva (CDN terzo, ~2 s) `.product-config` prende la classe
 * `is-non-disponibile` ed emette `murals:configurator:unavailable`: chi legge
 * il ritaglio (murals-request-list.js) deve trattarlo come assente.
 *
 * murals-request-list.js legge gli stessi selettori, e window.refW/refH per il
 * ripiego «intera grafica»: restano esposti.
 */
(function () {
  var jcp = null;
  var jcp_widget = null;
  var totW = 0, totH = 0;

  function cfg() {
    var img = document.getElementById('config-pattern');
    var host = img ? (img.closest('[data-ref-w]') || img) : null;
    var ds = (host && host.dataset) || {};
    var refW = parseFloat(ds.refW) || 472;
    var refH = parseFloat(ds.refH) || 300;
    var panel = parseFloat(ds.panel) || 0;
    window.refW = refW; window.refH = refH;
    return { img: img, refW: refW, refH: refH, panel: panel, quantity: ds.quantity || '' };
  }

  // Larghezza del telo: fissa se il catalogo la passa, altrimenti dal supporto
  // (Murals: textile/soft 59, kind 53, wet 47).
  function panelWidth(c) {
    if (c.panel > 0) return c.panel;
    var type = $('.product-config .product-type .variant-color.selected').attr('data-value');
    switch (type) {
      case 'kind': return 53;
      case 'wet':  return 47;
      default:     return 59;
    }
  }

  function setQuantity(c, v) {
    if (c.quantity) $(c.quantity).val(v);
  }

  function listen() {
    jcp.listen('crop.update', function (widget) {
      if (pendingImage || aligningFrame || imageFailed) return;
      jcp_widget = widget;
      updateConfiguratorData(widget);
    });
  }

  // La riga di stato sotto i campi. Vuota e nascosta quando non c'e' niente da
  // dire: non deve occupare spazio ne' essere letta dallo screen reader.
  function avviso(testo) {
    var el = document.querySelector('.product-config .config-avviso');
    if (!el) return;
    el.textContent = testo || '';
    if (testo) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }

  function emit(name) {
    try { document.dispatchEvent(new CustomEvent(name)); } catch (e) {}
  }

  var disponibile = false;
  var frameObserver = null;
  var frameW = 0, frameH = 0;
  var pendingImage = null;
  var aligningFrame = false;
  var imageFailed = false;

  function normalizedCrop() {
    var pos = jcp && jcp.active && jcp.active.pos;
    return pos && frameW && frameH ? {
      x: pos.x / frameW, y: pos.y / frameH,
      w: pos.w / frameW, h: pos.h / frameH
    } : null;
  }

  function alignOrnamiFrame() {
    if (!jcp || aligningFrame || (pendingImage && !pendingImage.loaded)) return;
    if (imageFailed && !pendingImage) return;
    var width = $('#config-pattern').width(), height = $('#config-pattern').height();
    if (!width || !height || (!pendingImage && width === frameW && height === frameH)) return;
    var rect = pendingImage ? pendingImage.rect : normalizedCrop();
    var widget = jcp.active;
    // Jcrop may emit crop.update while resizing: publish only the final rect.
    aligningFrame = true;
    try {
      jcp.resizeToImage();
      if (rect && widget) {
        widget.pos = Jcrop.Rect.create(rect.x * width, rect.y * height, rect.w * width, rect.h * height);
        widget.render();
        jcp.refresh();
      }
      frameW = width; frameH = height;
      pendingImage = null;
    } finally {
      aligningFrame = false;
    }
    if (imageFailed) {
      imageFailed = false;
      disponibile = true;
      var box = document.querySelector('.product-config');
      if (box) box.classList.remove('is-non-disponibile');
      $('.product-config .sizes input.num').each(function () {
        this.value = '0';
        this.disabled = false;
        this.removeAttribute('placeholder');
        this.removeAttribute('aria-disabled');
      });
      $('.product-config .sizes .tot .num').html('0.00');
      $('.product-config .info-hover').show();
      avviso('');
      emit('murals:configurator:update');
    }
    if (rect && widget) {
      jcp_widget = widget;
      updateConfiguratorData(widget);
    }
  }

  // Or.nami: keep Jcrop's pixel stage aligned with the rendered image when
  // columns change or the device rotates. The physical crop stays unchanged.
  function observeOrnamiFrame(img) {
    if (!img.closest('.ornami-config')) return;
    frameW = $('#config-pattern').width(); frameH = $('#config-pattern').height();
    alignOrnamiFrame();
    if (typeof ResizeObserver === 'undefined') return;
    if (frameObserver) frameObserver.disconnect();
    frameObserver = new ResizeObserver(alignOrnamiFrame);
    frameObserver.observe(img);
  }

  /*
    JCROP CHE NON ARRIVA e' un caso ordinario: viene da unpkg, un CDN terzo, e
    con rete lenta o bloccata la stazione fingeva di funzionare - invito
    «Trascina» acceso, campi che accettano numeri, richiesta con 40 x 0 cm.
    Qui si aspetta fino a ~2 s; poi la stazione lo dice: invito via, campi
    disabilitati, e la porzione si indica nel messaggio della richiesta.
  */
  function nonDisponibile() {
    var box = document.querySelector('.product-config');
    if (!box) return;
    box.classList.add('is-non-disponibile');
    $('.product-config .info-hover').hide();
    $('.product-config .sizes input.num').each(function () {
      this.value = '';
      this.disabled = true;
      this.setAttribute('placeholder', '\u2014');
      this.setAttribute('aria-disabled', 'true');
    });
    $('.product-config .sizes .tot .num').html('\u2014');
    $('#config-parameters').val('');
    avviso('Il configuratore non \u00e8 disponibile in questo momento. Indica la porzione che ti interessa nel messaggio della richiesta: la aggiungiamo noi.');
    emit('murals:configurator:unavailable');
  }

  function cropInit() {
    var c = cfg();
    if (!c.img) return;
    $('.product-config .sizes .w .num').val(0);
    $('.product-config .sizes .h .num').val(0);
    $('.product-config .sizes .tot .num').html('0.00');
    setQuantity(c, 0);
    $('#config-parameters').val('');

    var tentativi = 0;
    (function attendi() {
      if (typeof Jcrop !== 'undefined') {
        Jcrop.load('config-pattern').then(function (img) {
          jcp = Jcrop.attach(img, { multi: false });
          disponibile = true;
          listen();
          observeOrnamiFrame(img);
        }, nonDisponibile);
        return;
      }
      if (++tentativi > 8) { nonDisponibile(); return; }
      setTimeout(attendi, 250);
    })();
  }

  function updateConfiguratorData(widget) {
    if (pendingImage || aligningFrame || imageFailed) return;
    var c = cfg();
    totW = $('#config-pattern').width();
    totH = $('#config-pattern').height();
    var panel = panelWidth(c);

    $('.product-config .info-hover').hide();
    if (window.scroll && typeof window.scroll.update === 'function') window.scroll.update();

    var w = widget.pos.w, h = widget.pos.h, x = widget.pos.x, y = widget.pos.y;

    // Fractional responsive pixels must not turn a typed 40 cm into 39 cm.
    var centimetri = c.img.closest('.ornami-config') ? Math.round : Math.floor;
    var resultW = centimetri(w * c.refW / totW);
    var resultH = centimetri(h * c.refH / totH);
    var resultX = centimetri(x * c.refW / totW);
    var resultY = centimetri(y * c.refH / totH);

    if (c.img.closest('.ornami-config')) {
      resultW = Math.max(0, Math.min(resultW, c.refW));
      resultH = Math.max(0, Math.min(resultH, c.refH));
      resultX = Math.max(0, Math.min(resultX, c.refW - resultW));
      resultY = Math.max(0, Math.min(resultY, c.refH - resultH));
    }

    var m2 = ((resultW / 100) * (resultH / 100)).toFixed(2);

    $('.product-config .sizes .w .num').val(resultW);
    $('.product-config .sizes .h .num').val(resultH);
    $('.product-config .sizes .tot .num').html(m2);

    // Sfrido: larghezza arrotondata al telo intero, +20 cm in altezza.
    var finalW = Math.ceil(resultW / panel) * panel;
    var finalH = resultH + 20;
    if (finalH > c.refH) finalH = c.refH;
    var cm2 = Math.floor((finalW * finalH) / 100);
    setQuantity(c, cm2);

    var config = {
      x: resultX + 'cm',
      y: resultY + 'cm',
      width: resultW + 'cm',
      height: resultH + 'cm',
      m2: m2,
      m2_sfrido: (cm2 / 100).toFixed(2)
    };
    $('#config-parameters').val(JSON.stringify(config));
    emit('murals:configurator:update');
  }

  // Niente ritaglio: campi a zero, payload vuoto. E' lo stato di partenza e
  // quello in cui si torna quando il cliente azzera una misura.
  // `mantieni`: lascia i campi come sono. Serve quando il cliente ha scritto
  // solo la prima misura e sta per scrivere la seconda: azzerargli la prima
  // sotto le dita e' il difetto che ha rotto RB-1 al primo giro.
  function svuotaRitaglio(mantieni) {
    var c = cfg();
    if (!mantieni) {
      $('.product-config .sizes .w .num').val(0);
      $('.product-config .sizes .h .num').val(0);
    }
    $('.product-config .sizes .tot .num').html('0.00');
    setQuantity(c, 0);
    $('#config-parameters').val('');
    if (jcp && jcp.active && typeof jcp.removeWidget === 'function') {
      try { jcp.removeWidget(jcp.active); } catch (e) {}
    }
    jcp_widget = null;
    emit('murals:configurator:update');
  }

  // Or.nami may change aspect ratio. Keep the crop relative to the LAST
  // aligned frame: the caller may already have changed the CSS dimensions.
  // Murals retains its existing synchronous source-change behavior.
  function setPatternImage(src) {
    var img = cfg().img;
    if (img && img.closest('.ornami-config')) {
      var change = { rect: pendingImage ? pendingImage.rect : normalizedCrop(), loaded: false };
      if (pendingImage) pendingImage.cleanup();
      change.cleanup = function () {
        img.removeEventListener('load', change.onLoad);
        img.removeEventListener('error', change.onError);
      };
      change.onLoad = function () {
        if (pendingImage !== change) return;
        change.cleanup();
        change.loaded = true;
        alignOrnamiFrame();
      };
      change.onError = function () {
        if (pendingImage !== change) return;
        change.cleanup();
        pendingImage = null;
        imageFailed = true;
        disponibile = false;
        svuotaRitaglio(false);
        nonDisponibile();
      };
      pendingImage = change;
      img.addEventListener('load', change.onLoad);
      img.addEventListener('error', change.onError);
      img.src = src;
      if (img.complete) {
        if (img.naturalWidth > 0) change.onLoad(); else change.onError();
      }
      return;
    }
    $('#config-pattern').attr('src', src);
    if (jcp_widget) updateConfiguratorData(jcp_widget);
  }

  function typeSelect(element) {
    $('.product-config .user-choice .product-type .selected').removeClass('selected');
    $(element).addClass('selected');
    if (jcp_widget) updateConfiguratorData(jcp_widget);
  }

  /*
    LE MISURE SCRITTE A MANO sono l'unica via da tastiera - Jcrop non ha
    maniglie raggiungibili con Tab - e fino all'11/9 la rompevano: il widget
    veniva distrutto e ricreato, la creazione programmatica non emette
    `crop.update`, e cosi' i campi dicevano 40 x 30 mentre m2 e payload
    restavano vuoti (o vecchi). Ora:
      - il valore si legge, si valida e si riporta al limite PRIMA di toccare
        Jcrop, con una riga che dice cosa e' successo;
      - il widget esistente viene spostato (pos + render), non ricreato: il
        trascinamento con il mouse continua a funzionare dopo;
      - campi, m2 e payload escono da UN solo calcolo, `updateConfiguratorData`,
        chiamata esplicitamente sul widget.
  */
  function leggiMisura(sel, max, nome) {
    var $el = $(sel);
    var grezzo = String($el.val() || '').replace(',', '.').trim();
    var n = grezzo === '' ? 0 : Number(grezzo);
    var msg = '';
    if (!isFinite(n) || n < 0) {
      n = 0;
      msg = 'Solo numeri, in centimetri: ' + nome + ' riportata a 0.';
    } else if (n > max) {
      n = max;
      msg = nome.charAt(0).toUpperCase() + nome.slice(1) + ' riportata a ' + max + ' cm, il massimo del modulo.';
    }
    n = Math.round(n);
    $el.val(n);
    return { v: n, msg: msg };
  }

  function updateCrop() {
    if (pendingImage || aligningFrame || imageFailed) return;
    var c = cfg();
    var W = leggiMisura('.product-config .sizes .w .num', c.refW, 'larghezza');
    var H = leggiMisura('.product-config .sizes .h .num', c.refH, 'altezza');
    avviso(W.msg || H.msg);

    if (!jcp || !disponibile) return;

    if (W.v <= 0 || H.v <= 0) { svuotaRitaglio(true); return; }

    totW = $('#config-pattern').width();
    totH = $('#config-pattern').height();

    var x = 0, y = 0;
    if (jcp.active) { x = jcp.active.pos.x; y = jcp.active.pos.y; }

    var resultW = W.v * totW / c.refW;
    var resultH = H.v * totH / c.refH;
    if ((resultW + x) > totW) x = Math.max(0, totW - resultW);
    if ((resultH + y) > totH) y = Math.max(0, totH - resultH);

    var rect = Jcrop.Rect.create(x, y, resultW, resultH);
    var widget = null;
    if (jcp.active && typeof jcp.active.render === 'function') {
      jcp.active.pos = rect;
      jcp.active.render();
      widget = jcp.active;
    } else {
      widget = jcp.newWidget(rect) || jcp.active;
    }
    if (!widget) return;
    jcp_widget = widget;
    updateConfiguratorData(widget);
  }

  function openConfiguratore() {
    $('.product-config').toggleClass('open');
    setTimeout(cropInit, 500);
  }

  window.cropInit = cropInit;
  window.updateConfiguratorData = updateConfiguratorData;
  window.setPatternImage = setPatternImage;
  window.typeSelect = typeSelect;
  window.updateCrop = updateCrop;
  window.openConfiguratore = openConfiguratore;
  window.MuralsConfigurator = {
    init: cropInit,
    setImage: setPatternImage,
    widget: function () { return jcp_widget; },
    available: function () { return disponibile; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cropInit);
  } else {
    cropInit();
  }
})();
